// import moment from "moment";
import { Instability } from 'shared/types/instability';

const instabilities: Instability[] = [];

export default instabilities;
